/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TClaimGroup, TJoin, TModule, TNonEmptyArray, TPermissionGroup, TTenant } from "../../helpers/utils.graphql";
import { CommandResult, ListCommandResult } from "../fragment.graphql";
import { CommandResult_PermissionGroup, ListCommandResult_PermissionGroup } from "../../helpers/types.graphql";

export type TGlobal = TPermissionGroup
  | TJoin<"tenant", TTenant>
  | TJoin<"module", TModule>
  | TJoin<"claimGroups", TClaimGroup>

type TPermissionGroupByIdFunctions = { getByID: CommandResult_PermissionGroup }
export type TPermissionGroupByIdQueries = { permissionGroup: TPermissionGroupByIdFunctions };
export const permissionGroupById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query permissionGroupById($id: Guid!) {
    permissionGroup {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_PermissionGroup")}
`;

type TPermissionGroupAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_PermissionGroup }
export type TPermissionGroupAllWithPaginationQueries = { permissionGroup: TPermissionGroupAllWithPaginationFunctions };
export const permissionGroupAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query permissionGroupAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    permissionGroup {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_PermissionGroup")}
`;

type TPermissionGroupAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_PermissionGroup }
export type TPermissionGroupAllWithSortedPaginationQueries = { permissionGroup: TPermissionGroupAllWithSortedPaginationFunctions };
export const permissionGroupAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query permissionGroupAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    permissionGroup {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_PermissionGroup")}
`;